import type { AdoptToBaseOutcome } from 'config-hub-server/src/domain/adoptToBase.js';

/**
 * **Adopt to master**'s confirm: the dry run's per-environment outcomes, grouped into the lines the
 * dialog shows, in a fixed order, empty groups dropped. Pure; the dialog only renders.
 */
const GROUPS: { outcome: AdoptToBaseOutcome; heading: string }[] = [
    { outcome: 'matches', heading: 'Then matches' },
    { outcome: 'differs', heading: 'Then differs, needs a push' },
    { outcome: 'overridden', heading: 'Unchanged, an override decides it there' },
    { outcome: 'unknown', heading: 'Not known, not pulled' },
];

export const outcomeLines = (
    environments: readonly { name: string; outcome: AdoptToBaseOutcome }[],
): { heading: string; environments: string[] }[] =>
    GROUPS.map(({ outcome, heading }) => ({
        heading,
        environments: environments.filter((e) => e.outcome === outcome).map((e) => e.name),
    })).filter((line) => line.environments.length > 0);
